import _jsx from "@babel/runtime/helpers/jsx";
import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Glyphicon, Button } from 'reaxl';
import { sendImpressions, DelayedImpressionObserver } from 'reaxl-analytics';
import PhoneNumberCallAction from '../PhoneNumberCallAction/index.js';

/**
 *  The phone number Link component will accept text and a number by clicking on text it shows the phone number
 *  followed by extension
 *
 */
function PhoneNumberRevealAction(_ref) {
  var _PhoneNumberCallActio;
  let {
    className,
    extension,
    isButton,
    isCallable,
    isVisible = false,
    linkText = "Get this seller's phone number",
    onCall,
    onReveal = () => {},
    phoneNumber,
    showIcon = false,
    isSnapshot = false,
    ...rest
  } = _ref;
  const pageName = useSelector(state => _get(state, 'currentPageName', ''));
  const [visibility, setVisibility] = useState(isVisible);
  const handleReveal = event => {
    onReveal(event);
    setVisibility(true);
  };
  const handleInViewImpression = useCallback(() => {
    if (pageName === 'vdp') {
      sendImpressions({
        name: 'ownerPhoneNumberImpressions',
        data: {
          linkText
        }
      });
    }
  }, [linkText, pageName]);
  const renderPhoneNumber = () => _PhoneNumberCallActio || (_PhoneNumberCallActio = /*#__PURE__*/_jsx(PhoneNumberCallAction, {
    className: className,
    extension: extension,
    isCallable: isCallable,
    isButton: isButton,
    onCall: onCall,
    phoneNumber: phoneNumber,
    showIcon: showIcon,
    isSnapshot: isSnapshot
  }));
  const renderPhoneLink = () => {
    delete rest.extension;
    delete rest.phoneNumber;
    delete rest.isVisible;
    delete rest.onReveal;
    delete rest.isCallable;
    delete rest.onCall;
    delete rest.preferredCTA;
    delete rest.clickType;
    return /*#__PURE__*/_jsx(DelayedImpressionObserver, {
      onChange: () => handleInViewImpression()
    }, "phone-number-reveal-action-resources-delayed-impression", /*#__PURE__*/React.createElement(Button, Object.assign({
      "data-cmp": "phoneNumberLink",
      className: clsx({
        'display-flex': isSnapshot
      }, className),
      onClick: e => handleReveal(e)
    }, rest, {
      bsStyle: "text"
    }), showIcon && /*#__PURE__*/_jsx(Glyphicon, {
      glyph: "phone",
      className: clsx('margin-right-2', {
        'text-size-500 margin-right-3 link-unstyled': isSnapshot
      }),
      "aria-hidden": "true"
    }), linkText));
  };
  return visibility ? renderPhoneNumber() : renderPhoneLink();
}
export default PhoneNumberRevealAction;